"use strict";
import $ from "jquery";
import _ from "underscore";
import DataStoreService from "../accounts_payable/data_store_service";
import ApiService from "../services/api_service";
export default {
  markIllegible: function(documentPage) {
    return ApiService.addErrorHandler(
      // TODO: use fetch instead
      // eslint-disable-next-line no-restricted-syntax
      $.ajax({
        url: "/api/document_pages/" + documentPage.id + "/illegible",
        type: "POST",
        contentType: "application/json"
      }).then(DataStoreService.responseHandler, _.identity)
    );
  },
  markHidden: function(documentPage, isHidden) {
    return ApiService.addErrorHandler(
      // TODO: use fetch instead
      // eslint-disable-next-line no-restricted-syntax
      $.ajax({
        url: "/api/document_pages/" + documentPage.id + "/hidden",
        data: JSON.stringify({ hidden: isHidden }),
        type: "POST",
        contentType: "application/json"
      }).then(DataStoreService.responseHandler, _.identity)
    );
  }
};
